module.exports = __webpack_public_path__ + "static/img/bsfa2.755b3282.png";